module.exports = __webpack_public_path__ + "img/beite-banner.9889a489.png";